"use client"
import { models } from "powerbi-client";
import { User } from "./user";
import { Report } from "./report";
export enum IPowerBIType{
  EXPORT = 1,
  IMPORT = 2,
  SHARE = 3,
  BOOKMARK = 4,
}
export interface IReportLoadConfiguration {
    accessToken: string;
    bookmark?: models.IApplyBookmarkRequest;
    contrastMode?: models.ContrastMode;
    datasetBinding?: models.IDatasetBinding;
    embedUrl?: string;
    filters?: models.ReportLevelFilters[];
    id: string;
    pageName?: string;
    permissions?: models.Permissions;
    settings?: any;
    slicers?: models.ISlicer[];
    theme?: models.IReportTheme;
    tokenType?: models.TokenType;
    type: string;
    viewMode?: models.ViewMode;
}

export interface PowerBi {
    id: number,
    userId: number;
    reportId: number;
    token: string;
    bookmarkName: string;
    bookmarkState:string;
    language: string;
    createdAt: Date;
    updatedAt: Date;
    deletedAt: Date;
    user: User;
    report: Report;
}


export interface SlicerData {
  slicerId: string;
  slicerName: string;
  fieldName: string;
  value: string | number;
}
  
export interface BookmarkData {
    pageId: string,
    pageName: string,
    slicers: SlicerData[];
}